/**
 * @file Video Content
 */

import { gsap } from 'gsap';
import ScrollTrigger from 'gsap/ScrollTrigger';

/**
 * Video Content component
 */
const vVideoContent = () => {
	const videoContent = document.querySelector( '.v-video-content' );

	if ( ! videoContent ) {
		return;
	}

	gsap.registerPlugin( ScrollTrigger );

	const content     = videoContent.querySelector( '.v-video-content__content-inner' );
	const tweenVars   = {
		opacity:  1,
		duration: 1,
		ease:     'power1.inOut',
	};
	const triggerVars = {
		trigger:       videoContent,
		toggleActions: 'play none none reset',
	};

	gsap.fromTo( content, { opacity: 0 }, {
		...tweenVars,
		scrollTrigger: {
			start: 'top bottom-=10%',
			...triggerVars,
		},
	} );
};

export default vVideoContent;
